import React, { useCallback } from 'react';

import IconButton from '@atlaskit/button/icon/button';
import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import { useHerStore } from '../hooks/useHerStore';

import { Constellation } from './constellation/Constellation';

const styles = cssMap({
	icon: {
		height: '24px',
		width: '24px',
	},
});

const getAudioLevel = (): number => 0;

export function HerButton({
	contentId,
	cloudId,
	contentType,
}: {
	contentId: string;
	cloudId: string;
	contentType: string;
}): React.JSX.Element {
	const { isHerActive, toggleHer } = useHerStore();

	const handleClick = useCallback(() => {
		toggleHer(contentId, cloudId, contentType);
	}, [toggleHer, contentId, cloudId, contentType]);

	return (
		<Tooltip content="Rovo Voice" position="left">
			<IconButton
				appearance="subtle"
				icon={() => (
					<Box as="span" xcss={styles.icon}>
						<Constellation
							active={isHerActive}
							getAudioLevel={getAudioLevel}
							paused={false}
							pose="still"
						/>
					</Box>
				)}
				label="Rovo Voice"
				shape="default"
				isSelected={isHerActive}
				onClick={handleClick}
				testId="enterprise-her-button"
			/>
		</Tooltip>
	);
}
